import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-error-generico',
    templateUrl: './error-generico.component.html',
    styleUrls: ['./error-generico.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorGenericoComponent {

  @Input() errorGenerico = false;
  @Output() alertErrorFechou = new EventEmitter();

  constructor() { }

  fechar() { this.alertErrorFechou.emit('Fechou'); }

}
